module.exports = __webpack_public_path__ + "static/media/edu2.05ab9b5e.jpg";